<div
  class="wrapper--toggle nx-formfield__wrapper"
  [formGroup]="formGroup"
  [ngClass]="{'centered-group': field.centerGroup}"
>
  <div class="wrapper--toggle--content">
    <div class="wrapper--toggle--title" *ngIf="field.showLabel || false">
      <nx-label>
        {{ field.label | translate }}
      </nx-label>
    </div>
    <div class="wrapper--toggle--description" *ngIf="field.customDescription">
      <p>{{ field.customDescription | translate }}</p>
    </div>
    <nx-radio-toggle
      #radioToggle
      [formControlName]="field.name"
      [variant]="field.variant ?? 'normal'"
    >
      <nx-radio-toggle-button
        *ngFor="let item of field.list"
        [value]="item.value"
        [selected]="item.selected || false"
      >
        {{ item.text | translate }}
      </nx-radio-toggle-button>
      <app-popover-form
        *ngIf="field.popover"
        [popover]="field.popover"
        (popoverShow)="onPopoverShow($event)"
      ></app-popover-form>
    </nx-radio-toggle>
  </div>
</div>
